import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { SecretsActions } from 'Redux/thunks/secrets.thunks';
import { EnvVarActions } from 'Redux/thunks/vars.thunks';
import EnvVariables from '../../components/env-variables';
import { Secrets } from '../../components/secrets/Secrets';
import { DatahubSettings } from '../../../containers/DatahubSettings.container';

import type { RootState } from 'src/types/state.types';

export const SettingsVariables: React.FC = () => {
  const dispatch = useDispatch();
  const token = useSelector((state: RootState) => state.subscription.token);

  useEffect(() => {
    if (token) {
      dispatch(EnvVarActions.envLoadAll());
      dispatch(SecretsActions.secretLoadAll());
    }
  }, [token]);

  return (
    <DatahubSettings>
      <main className="scrollArea">
        <div className="row">
          <section className="col col--elastic gr-equal">
            <h3 className="heading-section">Environment variables</h3>
            <EnvVariables />
          </section>
          <section className="col col--elastic gr-equal">
            <h3 className="heading-section">Secrets</h3>
            <Secrets />
          </section>
        </div>
      </main>
    </DatahubSettings>
  );
};
